import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class RendererPcvizService {
    getPanoramaSymbol3D(): typeof PointCloudViz.Renderer.PanoramaSymbol3D {
        return PointCloudViz.Renderer.PanoramaSymbol3D;
    }
}
